import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getChangeNumberLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const ChangeNumberHistory = (props) => {
  const [changeNumberHistory, setChangeNumberHistory] = useState([]);
  const { change_number_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getChangeNumberLog(change_number_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setChangeNumberHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Change Number Log
        </Typography>
      </Box>

      {response && changeNumberHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ICCID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Zipcode</TableCell>
                    <TableCell align="left">MSISDN</TableCell>
                    <TableCell align="left">Old MSISDN</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {changeNumberHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/it/change_number/batch/${changeNumberHistory.data.batch_id}`}
                      >
                        {changeNumberHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={changeNumberHistory.data.status}
                        size="small"
                        color={getChipColor(changeNumberHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {changeNumberHistory.data.zipcode}
                    </TableCell>
                    <TableCell align="left">
                      {changeNumberHistory.data.new_msisdn || changeNumberHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      {changeNumberHistory.data.old_msisdn}
                    </TableCell>
                    <TableCell align="left">
                      {changeNumberHistory.data.last_updated &&
                        `${format(
                          new Date(changeNumberHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={changeNumberHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ChangeNumberHistory;
